<script setup>
defineProps(['imgSrc', 'title']);
</script>

<template>
  <div class="flex flex-col text-center w-full">
    <div class="rounded-2xl overflow-hidden w-full h-full">
      <img
        class="rounded-2xl w-full h-full object-cover"
        :src="imgSrc"
        alt="Course Preview image"
      >
    </div>
    <h3 class="text-sm font-bold leading-6 mt-3 min-h-[3rem] flex items-start justify-center">
      {{ title }}
    </h3>
  </div>
</template>
